import React from 'react';
import { Link } from 'react-router-dom';
import Tag from '../Tag/Tag';
import styles from './ResourceCard.module.css';

const ResourceCard = ({ resource }) => {
  const {
    id,
    title,
    description,
    fileSize,
    price,
    downloadCount,
    viewCount,
    tags = [],
    purchased = false,
    createdAt,
    source,
    items
  } = resource;

  const displayItems = items && items.length > 0 ? items : [resource];

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('zh-CN');
  };

  const formatNumber = (num) => {
    if (num >= 10000) {
      return (num / 10000).toFixed(1) + 'w';
    }
    return num?.toLocaleString() || 0;
  };

  return (
    <div className={styles.resourceCard}>
      <div className={styles.resourceHeader}>
        {displayItems.length === 1 ? (
          <Link to={`/resource/${displayItems[0].id}`} className={styles.resourceTitle}>
            {title}
          </Link>
        ) : (
          <span className={styles.resourceTitle}>{title}</span>
        )}
        <div className={styles.resourceStatus}>
          {purchased && (
            <span className={`${styles.statusBadge} ${styles.purchased}`}>
              已购买
            </span>
          )}
        </div>
      </div>

      <div className={styles.resourceItemsList}>
        {displayItems.map((item, index) => (
          <div key={item.id} className={styles.resourceSubItem}>
            <div className={styles.subItemHeader}>
              <Link to={`/resource/${item.id}`} className={styles.sourceLink}>
                {item.source || '未知来源'}
              </Link>
              <div className={styles.subItemTags}>
                {item.tags && item.tags.map((tag, tIndex) => (
                  <Tag
                    key={tIndex}
                    name={tag}
                    size="small"
                    variant="default"
                  />
                ))}
              </div>
            </div>
            
            {item.description && (
              <Link to={`/resource/${item.id}`} className={styles.subItemDescription}>
                {item.description}
              </Link>
            )}
            
            <div className={styles.resourceMeta}>
              {item.fileSize && (
                <div className={styles.metaItem}>
                  <span className={styles.fileSize}>大小: {item.fileSize}</span>
                </div>
              )}
              <div className={styles.metaItem}>
                <span className={styles.viewCount}>查看次数: {formatNumber(item.viewCount)}</span>
              </div>
              <div className={styles.metaItem}>
                <span className={styles.downloadCount}>下载次数: {formatNumber(item.downloadCount)}</span>
              </div>
              <div className={styles.metaItem}>
                <span className={styles.date}>入库时间：{formatDate(item.createdAt)}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ResourceCard;